import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[(_vm.itemData)?[_vm._v("\n    "+_vm._s(_vm.itemData)+"\n  ")]:[_c(VChip,{attrs:{"label":"","outlined":"","color":"error"}},[_vm._v("No data")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }